import React from 'react';
import {TableDefault} from './styles';
import Media from '../Media/Media';

export default () => (
  <TableDefault>
    <thead>
      <tr>
        <th colSpan={3}></th>
        <th colSpan={6}>Throwing arm</th>
        <th colSpan={6}>Non-Throwing arm</th>
        <th colSpan={3}>Totals</th>
      </tr>
      <tr>
        <th>PLAYERS</th>
        <th>DATE</th>
        <th>EXAM</th>
        <th>PEAK R1</th>
        <th>TIME R1</th>
        <th>PEAK R2</th>
        <th>TIME R2</th>
        <th>PEAK R3</th>
        <th>TIME R3</th>
        <th>PEAK R1</th>
        <th>TIME R1</th>
        <th>PEAK R2</th>
        <th>TIME R2</th>
        <th>PEAK R3</th>
        <th>TIME R3</th>
        <th>T-ARM</th>
        <th>NT-ARM</th>
        <th>%DIFF</th>
      </tr>
    </thead>
    <tbody className="table-player-exam">
      <tr>
        <td>
          <Media name="John Hughes" />
        </td>
        <td>2/20/2020</td>
        <td>AC Exam</td>
        <td>14.1</td>
        <td>1.9</td>
        <td>56.3</td>
        <td>1.7</td>
        <td>-</td>
        <td>-</td>
        <td>14.1</td>
        <td>1.3</td>
        <td>54.5</td>
        <td>1.8</td>
        <td>-</td>
        <td>-</td>
        <td>53.4</td>
        <td>54.5</td>
        <td>6</td>
      </tr>
      <tr>
        <td>
          <Media name="John Hughes" />
        </td>
        <td>2/20/2020</td>
        <td>AC Exam</td>
        <td>14.1</td>
        <td>1.9</td>
        <td>56.3</td>
        <td>1.7</td>
        <td>-</td>
        <td>-</td>
        <td>14.1</td>
        <td>1.3</td>
        <td>54.5</td>
        <td>1.8</td>
        <td>-</td>
        <td>-</td>
        <td>53.4</td>
        <td>54.5</td>
        <td>6</td>
      </tr>
      <tr>
        <td>
          <Media name="John Hughes" />
        </td>
        <td>2/20/2020</td>
        <td>AC Exam</td>
        <td>14.1</td>
        <td>1.9</td>
        <td>56.3</td>
        <td>1.7</td>
        <td>-</td>
        <td>-</td>
        <td>14.1</td>
        <td>1.3</td>
        <td>54.5</td>
        <td>1.8</td>
        <td>-</td>
        <td>-</td>
        <td>53.4</td>
        <td>54.5</td>
        <td>6</td>
      </tr>
      <tr>
        <td>
          <Media name="John Hughes" />
        </td>
        <td>2/20/2020</td>
        <td>AC Exam</td>
        <td>14.1</td>
        <td>1.9</td>
        <td>56.3</td>
        <td>1.7</td>
        <td>-</td>
        <td>-</td>
        <td>14.1</td>
        <td>1.3</td>
        <td>54.5</td>
        <td>1.8</td>
        <td>-</td>
        <td>-</td>
        <td>53.4</td>
        <td>54.5</td>
        <td>6</td>
      </tr>
    </tbody>
  </TableDefault>
);
